import type { MaybeRefOrGetter } from 'vue'
import { breadcrumbList } from '~/helpers/structuredData'
import type { Breadcrumb } from '~/types/breadcrumb'

/** BreadcrumbList structured data for the crumbs. One per page: every caller uses the same key. */
export function useBreadcrumbStructuredData(crumbs: MaybeRefOrGetter<Breadcrumb[] | null>) {
  const baseUrl = useRuntimeConfig().public.BASE_URL as string
  useHead(() => {
    const data = breadcrumbList(toValue(crumbs) || [], baseUrl)
    return { script: data ? [{ key: 'breadcrumb-ld', type: 'application/ld+json', children: JSON.stringify(data) }] : [] }
  })
}
